module.exports = __webpack_public_path__ + "img/logo10.3a34e4e7.png";